<!--
 * @Author: your name
 * @Date: 2022-01-04 20:04:13
 * @LastEditTime: 2022-01-26 16:07:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ksh-doctor/src/components/ImagePreview.vue
-->
<template>
  <div class="preview-wrapper">
    <swiper class="swiper-body" :options="swiperOption" ref="previewSwiper">
      <swiper-slide v-for="(item,key,index) in imageList" v-bind:key="index">
        <div class="swiper-zoom-container">
          <img class="cover-img" v-bind:src="item"/>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
export default {
  name: 'ImagePreviewModal',
  props: {
    imageList: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      swiperOption: {
        speed: 500,
        preloadImages: false,
        zoom: true,
        zoomMax :3,
        pagination: {
          el: '.swiper-pagination',
          type: "fraction",
          // renderCustom: (swiper, current, total) => {
          //   return current + ' / ' + total;
          // },
        },
        on: {
          click: ()=>{
            this.hidePreview()
          }
        }
      },
    }
  },
  computed: {
    previewSwiper() {
      return this.$refs.previewSwiper.swiper
    },
  },
  watch: {
    activeIndex(newVal) {
      this.previewSwiper && this.previewSwiper.slideTo(newVal, 1000, false)
    }
  },
  methods: {
    hidePreview() {
      this.$emit('hidePreview')
    },
  }
}
</script>

<style lang="scss" scoped>
.preview-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper-body {
  height: 100vh;
  overflow: auto;
}
.swiper-pagination.swiper-pagination-fraction {
  font-size: $font-size-mini;
  color: $color-white;
}
.cover-img {
  width: 100%;
}

</style>
